/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './ShareOfMind.css';

import CustomChart from '../../../components/CustomChart/CustomChart'
import { _shareOfMind } from '../../../chart';
import { CustomizedForm } from '../components/baseForm'
import baseFiled from '../components/baseFiled';
import SefeImport from '../components/ShareOfMind'
import { isArray } from 'util';

const checkPx = (str) => {
  let _str = str + '';
  if (_str.indexOf('%')) {
    return _str;
  } else {
    return _str + 'px'
  }
}

class ShareOfMind extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      fields: {
        ...Object.assign(baseFiled, {
          titleText: {
            value: '短视频行业心智占有率'
            
          },
          subTitleText: {
            value: '2019.12.09'
          }
        })
      },
      list: [],
      colorList: [{
        name: '顺意群体',
        value: 'agreeable',
        color: '#676767'
      }, {
        name: '中立群体',
        value: 'neutrality',
        color: '#bfbebf'
      }, {
        name: '逆意群体',
        value: 'reverse',
        color: '#9b9b9b'
      }],
      chartWidth: '100%',
      chartHeight: '100%',
      chart: _shareOfMind(),
    }

    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount () {
    this.setState({
      list: [{"name":"抖音","value":"1005549818"},{"name":"快手","value":"494379853"},{"name":"微视","value":"267617355"},{"name":"秒拍","value":"232580974"},{"name":"美拍","value":"62891672"}],
    }, this.init)
  }

  init = () => {
    const {fields, list, colorList} = this.state;

    const chart = _shareOfMind({
      ...fields,
      list,
      colorList
    })
    
    this.setState({
      chartHeight: checkPx(fields.chartHeight.value),
      chartWidth: checkPx(fields.chartWidth.value),
      chart: chart
    })

  }

  handleFormChange (props, changedFields) {
    this.setState(({ fields }) => ({
      fields: {
        ...fields,
        ...changedFields
      }
    }));
  }

  handleAdd (props, changedFields) {

    if (isArray(changedFields)) {
      this.setState({
        list: changedFields
      })
    } else {
      const colorList = this.state.colorList;
      const color = changedFields.color;
      
      color.forEach((item, index) => {
        colorList[index].color = item.value
      });

      this.setState({
        colorList: colorList
      })

    }
  }

  removeItem = (index) => {
    const {list} = this.state
    list.splice(index, 1)
    this.setState({list})
  }

  handleClick () {
    this.init()
  }

  render() {
    const {fields, list, colorList, chartWidth, chartHeight} = this.state;
    return (
      <CustomChart 
        width={chartWidth} 
        height={chartHeight} 
        chart={this.state.chart}
        callback={this.handleClick}
      >
        <SefeImport list={list} color={colorList} onChange={this.handleAdd} />
        <CustomizedForm {...fields} onChange={this.handleFormChange} />
      </CustomChart>
    );
  }
}

export default withStyles(s)(ShareOfMind);



// WEBPACK FOOTER //
// src/routes/customChart/ShareOfMind/ShareOfMind.js